module.exports = __webpack_public_path__ + "static/header2-a0f50bf06d0ee60d4a3a3e9757e08187.jpg";